import adoption from "./images/Rectangle-1.png";
import accommodation from "./images/Rectangle-2.png";
import entrepreneurship from "./images/Rectangle-3.png";
import skills from "./images/Rectangle.png";

const list = [
    {
        id: 1,
        title: "Adoption",
        para: "Adoption of Abandoned Children.",
        img: skills
    },
    {
        id: 2,
        title: "Accommodation",
        para: "Accommodating Orphans and Vulnerable Children. ",
        img: adoption
    },
    {
        id: 3,
        title: "Entrepreneurship",
        para: "Teaching of Entrepreneurship to the youths.",
        img: accommodation
    },
    {
        id: 4,
        title: "Recreation and Skills",
        para: "Youths Recreation and Skills Centre.",
        img: entrepreneurship
    }
];

export default list;